import React, { useState } from 'react'

interface Props {
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
  required?: boolean
  disabled?: boolean
  error?: string
}

const EstigroupCheckbox = ({
  label,
  checked,
  onChange,
  required = false,
  disabled = false,
  error = ''
}: Props): JSX.Element => {
  const [isFocused, setIsFocused] = useState(false)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    onChange(e.target.checked)
  }

  const handleFocus = (): void => {
    setIsFocused(true)
  }
  const handleBlur = (): void => {
    setIsFocused(false)
  }

  return (
    <div className="self-stretch flex flex-col justify-start items-start gap-1">
      <div className="self-stretch inline-flex justify-start items-start gap-2">
        <div className="w-5 h-5 relative">
          <input
            type="checkbox"
            checked={checked}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            disabled={disabled}
            className="absolute inset-0 w-5 h-5 opacity-0 cursor-pointer z-10"
          />
          <div
            style={{
              boxShadow: isFocused
                ? '0px 0px 0px 2px rgba(53, 130, 206, 0.2), 0px 1px 2px 0px rgba(0,0,0,0.12)'
                : '0px 0px 0px 1px rgba(0,0,0,0.08), 0px 1px 2px 0px rgba(0,0,0,0.12)'
            }}
            className={`w-5 h-5 relative bg-backgrounds-bg-component rounded-[3px] transition-all duration-200 ${
              checked ? 'bg-Estigroup-primary' : 'bg-backgrounds-bg-component'
            } ${isFocused ? 'ring-2 ring-Estigroup-primary ring-opacity-20' : ''} ${
              error.length > 0 ? 'border-red-500' : ''
            }`}>
            {checked && (
              <svg className="absolute inset-0 w-5 h-5 text-white" viewBox="0 0 20 20" fill="currentColor">
                <path
                  fillRule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </div>
        </div>
        <div className="flex-1 inline-flex flex-col justify-start items-start">
          <div className="self-stretch inline-flex justify-start items-center gap-1">
            <div
              className="flex-1 justify-center text-foregrounds-fg-base text-xs font-medium leading-tight cursor-pointer"
              onClick={(): void => {
                onChange(!checked)
              }}>
              {label}
              {required && <span className="text-red-500 ml-1">*</span>}
            </div>
          </div>
        </div>
      </div>
      {error.length > 0 && <div className="text-red-500 text-xs font-normal leading-tight ml-7">{error}</div>}
    </div>
  )
}

export default EstigroupCheckbox
